import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';
import { EGDSButtonSize, EGDSPrimaryButton } from '@egds/react-core/button';
import { EGDSIcon } from '@egds/react-core/icons';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSLineSkeleton } from '@egds/react-core/skeleton';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSText } from '@egds/react-core/text';
const onKeyDown = event => {
  if (event.key === 'Tab' && !event.shiftKey) {
    const mapFocusDummyElement = document.getElementById('map-focus-holder-entry');
    if (mapFocusDummyElement) {
      mapFocusDummyElement.focus();
    }
  }
};
const ButtonTracked = ClickTracker(EGDSPrimaryButton);
export const PaginationNavigation = ({
  onPrevPage,
  onNextPage,
  pagingPrevButton,
  pagingNextButton,
  isLoading,
  paginationLabel
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  return React.createElement(ErrorBoundary, {
    label: "hotel.search.paginationNavigationButtons"
  }, React.createElement(EGDSLayoutFlex, {
    "data-stid": "pagination-navigation",
    direction: "column",
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'four'
    }
  }, React.createElement(EGDSLayoutFlex, {
    space: "six",
    alignItems: "center",
    justifyContent: "center"
  }, React.createElement(EGDSSpacing, {
    margin: {
      inlineend: 'four'
    }
  }, React.createElement(ButtonTracked, {
    type: "button",
    "data-stid": "previous-button",
    "aria-label": (_a = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.accessibility) !== null && _a !== void 0 ? _a : '',
    size: EGDSButtonSize.MEDIUM,
    disabled: !pagingPrevButton || isLoading || ((_b = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.disabled) !== null && _b !== void 0 ? _b : false),
    onClick: onPrevPage,
    rfrr: (_d = (_c = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.analytics) === null || _c === void 0 ? void 0 : _c.referrerId) !== null && _d !== void 0 ? _d : '',
    linkName: (_f = (_e = pagingPrevButton === null || pagingPrevButton === void 0 ? void 0 : pagingPrevButton.analytics) === null || _e === void 0 ? void 0 : _e.linkName) !== null && _f !== void 0 ? _f : ''
  }, React.createElement(EGDSIcon, {
    name: "chevron_left"
  }))), isLoading ? React.createElement(EGDSLayoutFlexItem, {
    minWidth: 12,
    shrink: 0
  }, React.createElement(EGDSLineSkeleton, {
    type: "secondary"
  })) : paginationLabel && React.createElement(EGDSText, {
    size: 300,
    weight: "regular"
  }, paginationLabel), React.createElement(EGDSSpacing, {
    margin: {
      inlinestart: 'four'
    }
  }, React.createElement(ButtonTracked, {
    type: "button",
    "data-stid": "next-button",
    "aria-label": (_g = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.accessibility) !== null && _g !== void 0 ? _g : '',
    size: EGDSButtonSize.MEDIUM,
    disabled: !pagingNextButton || isLoading || ((_h = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.disabled) !== null && _h !== void 0 ? _h : false),
    onKeyDown: onKeyDown,
    onClick: onNextPage,
    rfrr: (_k = (_j = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.analytics) === null || _j === void 0 ? void 0 : _j.referrerId) !== null && _k !== void 0 ? _k : '',
    linkName: (_m = (_l = pagingNextButton === null || pagingNextButton === void 0 ? void 0 : pagingNextButton.analytics) === null || _l === void 0 ? void 0 : _l.linkName) !== null && _m !== void 0 ? _m : ''
  }, React.createElement(EGDSIcon, {
    name: "chevron_right"
  }))))), React.createElement(EGDSText, {
    size: 100,
    weight: "regular"
  })));
};
PaginationNavigation.displayName = 'PaginationNavigation';